import { render, staticRenderFns } from "./Peeps.vue?vue&type=template&id=35c96c94&scoped=true&"
import script from "./Peeps.vue?vue&type=script&lang=js&"
export * from "./Peeps.vue?vue&type=script&lang=js&"
import style0 from "./Peeps.vue?vue&type=style&index=0&id=35c96c94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c96c94",
  null
  
)

export default component.exports